import { ImageMediaProps } from '@/modules/Education/types/Education.type';

export default function ImageMedia({ src, alt }: ImageMediaProps) {
  return (
    <img
      src={src}
      alt={alt}
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  );
}
